module.exports = __webpack_public_path__ + "img/red_bg_1.e6e444f9.png";